import { PaginationState } from "@tanstack/react-table";

export const defaultPaginationState: PaginationState = {
  pageIndex: 0,
  pageSize: 10,
};

export const defaultPaginationStateMax: PaginationState = {
  pageIndex: 0,
  pageSize: 100,
};
